import React from "react";
import { Stack } from "@mui/material";
import { ShimmerThumbnail } from "react-shimmer-effects";

interface CommonShimmerProps {
    rows?: number;   // number of shimmer boxes
    height?: number; // height of each shimmer box
    width?: number;  // width of each shimmer box
}

const BoxShimmer: React.FC<CommonShimmerProps> = ({
    rows = 6,
    height = 160,
    width = 160,
}) => {
    return (
        <Stack
            direction="row"   // 👉 horizontal layout
            spacing={2}
            flexWrap="wrap"   // 👉 allows wrapping if not enough space
        >
            {Array.from(new Array(rows)).map((_, index) => (
                <ShimmerThumbnail
                    key={index}
                    height={height}
                    width={width}
                />
            ))}
        </Stack>
    );
};

export default BoxShimmer;
